import { useContext } from "react";
import "../../../styles/style.css";
import { projectTabContext, projectCurrentTabContext } from "../context/developer_project_context";

const ProjectTab = () => {
  const { tabs } = useContext(projectTabContext);
  const { currentTab, setTab } = useContext(projectCurrentTabContext);
  return (
    <>
      <div className=" sm:block pb-4">
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => setTab(tab)}
              className={`button-tab-base ${tab.name === currentTab.name ? "active" : "inactive"}`}
              aria-current={tab.name === currentTab.name ? "page" : undefined}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
    </>
  );
};

export default ProjectTab;